<template>
  <div class="secret">
    <el-page-header @back="goBack" title content="安全秘钥"></el-page-header>
    <div class="secret-form">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="秘钥:" prop="key">
          <el-input v-model="form.key" placeholder="请输入16位包含数字、字符、、特殊符号、字母的秘钥"></el-input>
        </el-form-item>
        <el-form-item label>
          <el-button @click="goBack">取消</el-button>
          <el-button type="primary" @click="showDialog">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="Tips" :visible.sync="dialogVisible" width="30%">
      <span>确认生成秘钥？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="subKey">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Secret",
  data() {
    let validate = (rule, value, callback) => {
      if (value.length != 16) {
        callback(new Error("请输入16位包含数字、字符、字母的秘钥"));
      } else {
        callback();
      }
    };
    return {
      form: {
        key: ""
      },
      rules: {
        key: [
          {
            required: true,
            message: "请输入秘钥",
            trigger: "blur"
          },
          {
            validator: validate,
            trigger: "blur"
          }
        ]
      },
      dialogVisible: false
    };
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
    showDialog: function() {
      this.dialogVisible = true;
    },
    subKey: function() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$api
        .post(`/xsss/v1/security?key=${this.form.key}`)
        .then(() => {
          this.dialogVisible = false;
          loading.close();
          this.$message({
            message: "秘钥生成成功",
            type: "success"
          });
        })
        .catch(() => {
          loading.close();
        });
    }
  }
};
</script>

<style  scoped>
@import url("./index.css");
</style>